import { Component, OnInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { Header } from 'src/app/models/header.model';

@Component({
  selector: 'app-image-viewer-modal',
  templateUrl: './image-viewer-modal.component.html',
  styleUrls: ['./image-viewer-modal.component.scss'],
})
export class ImageViewerModalComponent implements OnInit {

  public header: Header = {
    title: '',
    subtitle: '',
    principalPage: false,
    icon: 'close'
  }
  bodyClass: string = '';
  imageUrl: string = '';
  forceLight: boolean = false;

  constructor(private navParams: NavParams, public modalController: ModalController) { }

  ngOnInit() {
    this.imageUrl = this.navParams.get('imageUrl');
    this.header.title =  this.navParams.get('title');
    this.forceLight =  this.navParams.get('forceLight');
    if(this.forceLight){
      this.bodyClass = document.body.getAttribute('class');
      document.body.setAttribute('class', 'light');
    }
  }
  ionViewWillLeave(): void {
    document.body.setAttribute('class', this.bodyClass);
  }

}
